import { PatientLabsData } from '../../constants/api.config'
import getCharts from '../getCharts'


export default async function PatientLabsCRUD(mode, patientID = "-1", data = "", newDate = "-1", id = "-1") {
    try {
        const payload = { mode, data, patientID, id, newDate }
        const res = await getCharts(PatientLabsData, payload)
        return res.data
    } catch (error) {
        return error
    }
}
